module.exports = __webpack_public_path__ + "static/tari-342e93e1de6f5e440e124e3df709fe95.jpg";